<template>
  <v-app>
    <div v-if="loading" class="fill-height d-flex align-center justify-center">
      <Loading />
    </div>

    <v-main v-else>
      <Popups v-if="$route.name === 'Home'" />

      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Loading from "./components/widgets/Loading.vue";
import Popups from "./components/widgets/Popups.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} - ${this.name}`;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  mounted() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .catch((err) => console.error("Error loading informations:", err));

    this.$rest("social")
      .get()
      .catch((err) => console.error("Error loading social:", err));

    this.$rest("projects-topics")
      .get()
      .catch((err) => console.error("Error loading projects-topics:", err));

    this.$rest("services")
      .get()
      .then(() => (this.loading = false))
      .catch((err) => {
        console.error("Error loading services:", err);
        this.loading = false;
      });
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    Loading,
    Popups,
  },
};
</script>

<style>
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}

.container-xl {
  max-width: 1194px !important;
}

.filter-white {
  filter: brightness(0) invert(1);
}

.theme--light.v-pagination .v-pagination__item,
.theme--light.v-pagination .v-pagination__navigation {
  height: 50px;
  font-size: 18px;
  width: 50px;
}

.theme--light.v-pagination .v-pagination__navigation .v-icon {
  font-size: 18px;
}

.light-gallery__modal {
  z-index: 99999999 !important;
}

p:last-child {
  margin-bottom: 0;
}
</style>
